import { render, staticRenderFns } from "./UploadField.vue?vue&type=template&id=22cd5a8d&scoped=true&"
import script from "./UploadField.vue?vue&type=script&lang=js&"
export * from "./UploadField.vue?vue&type=script&lang=js&"
import style0 from "./UploadField.vue?vue&type=style&index=0&id=22cd5a8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cd5a8d",
  null
  
)

export default component.exports